/*
 * @Description: 客户结算单审批详情
 * @Author: 杨志航
 * @Date: 2026-06-22 15:53:16
 */

import React, { useState, useEffect } from 'react'
import {
  Descriptions,
  Spin,
  Icon,
  message,
  Button,
  Modal,
  Input,
  Form,
  Upload,
  Table,
  InputNumber,
  Row,
  Col,
  Checkbox,
} from 'antd'
import api from '@/api'
import { parseSearch, judgeCryptoParamsUrl, allTrim, filterParams } from '@/utils'
import { uploadDragger } from '@/utils/uploadDragger'
import { regExt } from '@/utils/constant'

const DItem = Descriptions.Item
const FormItem = Form.Item
const { Column } = Table
const { Dragger } = Upload
let draggerObj = {}

const Detail = (props) => {
  const { location, history } = props
  const { getFieldDecorator, validateFields, getFieldsValue, setFieldsValue, getFieldValue } = props.form
  const search = parseSearch(location.search)
  const [loading, setLoading] = useState(true)
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [logConList, setLogConList] = useState([])
  const [remark, setRemark] = useState('')
  const [order, setOrder] = useState({})
  const [relations, setRelations] = useState([])
  const [contractEmails, setContractEmails] = useState([])
  const [orderEmails, setOrderEmails] = useState([])
  const [customEmails, setCustomEmails] = useState([])
  const [emailVisible, setEmailVisible] = useState(false)
  const [emailAddress, setEmailAddress] = useState('')
  const [rejectVisible, setRejectVisible] = useState(false)
  const [rejectApprovers, setRejectApprovers] = useState([])
  const [statusLogs, setStatusLogs] = useState([])

  useEffect(() => {
    draggerObj = uploadDragger({
      accept: '.jpg, .jpeg, .png, .pdf',
      limitNum: 20,
      limitSize: 20,
    })
    if (judgeCryptoParamsUrl(search)) {
      getDetail()
    } else {
      message.error('没有本页访问权限')
      setTimeout(() => {
        history.goBack()
      }, 1000)
    }
  }, [])

  const initFormOrderData = order => {
    const { canApprove, currentApproverType, businessApprovers, currentUserId } = order
    if (canApprove && currentApproverType === 1) {
      const staffData = businessApprovers.find(item => item.staffId === currentUserId) || {}
      const { repaymentAmount, attachments, remark } = staffData
      if (repaymentAmount) {
        setFieldsValue({
          repaymentAmount,
        })
      }
      if (attachments) {
        setFieldsValue({
          attachments: JSON.parse(attachments).map((item, index) => {
            const { name, url } = item
            return {
              uid: index,
              name,
              status: 'done',
              url,
            }
          }),
        })
      }
      if (remark) {
        setFieldsValue({
          remark,
        })
      }
    }
  }

  //获取详情
  const getDetail = () => {
    setLoading(true)
    api.getSettlementOrderDetail({
      id: search.id
    }).then(data => {
      if (search.msgId) {
        api.setMessageReaded({ ids: [search.msgId] })
      }
      setLogConList(data.approverLogs)
      if (data.order.repaymentOaid === 0) {
        data.order.repaymentOaid = ''
      }
      initFormOrderData(data.order)
      setOrder(data.order)
      setRelations(data.relations)
      setContractEmails(data.currentEmails.contractEmails)
      setOrderEmails(data.currentEmails.orderEmails)
      setCustomEmails(data.currentEmails.customEmails)
      setStatusLogs(data.statusLogs)
      setLoading(false)
    }).catch(() => setLoading(false))
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 2 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    }
  }

  const consumeSummaryCol = [
    {
      title: '项目名称',
      dataIndex: 'projectName',
    },
    {
      title: '产品线',
      dataIndex: 'productLine',
    },
    {
      title: '返点政策/平均单价',
      dataIndex: 'rebatePolicy',
    },
    {
      title: '系统充值',
      dataIndex: 'systemRecharge',
    },
    {
      title: '本月市场价消耗',
      dataIndex: 'monthConsume',
    },
    {
      title: '赔付消耗/赠款消耗',
      dataIndex: 'compGiftConsume',
    },
    {
      title: '本月总消耗',
      dataIndex: 'totalConsume',
    },
    {
      title: '应付金额',
      dataIndex: 'payable',
    },
    {
      title: '已付金额',
      dataIndex: 'paid',
    },
    {
      title: '已撤资',
      dataIndex: 'cancelAmount',
    },
    {
      title: '以前期间应付未付金额',
      dataIndex: 'prevUnrecAmount',
    },
    {
      title: '应付未付金额',
      dataIndex: 'unpaidAmount',
    },
    {
      title: '累计应付未付金额',
      dataIndex: 'unpaidAmtAll',
    },
    {
      title: '月末系统余额（截至当月最后一天）',
      dataIndex: 'endBalance',
    },
   ]

   const accountDataCol = [
    {
      title: '项目名称',
      dataIndex: 'projectName',
    },
    {
      title: '原始厂商ID',
      dataIndex: 'vendorId',
    },
    {
      title: '厂商客户账号',
      dataIndex: 'vendorName',
    },
    {
      title: '系统充值',
      dataIndex: 'systemRecharge',
    },
    {
      title: '系统消耗',
      dataIndex: 'systemConsume',
    },
    {
      title: '应付金额',
      dataIndex: 'payable',
    },
    {
      title: '单价',
      dataIndex: 'price',
    },
    {
      title: '账户余额',
      dataIndex: 'accBalance',
    },
  ]

  const consumeDetailCol = [
    {
      title: '日期',
      dataIndex: 'date',
    },
    {
      title: '项目名称',
      dataIndex: 'projectName',
    },
    {
      title: '原始厂商ID',
      dataIndex: 'vendorId',
    },
    {
      title: '厂商客户账号',
      dataIndex: 'vendorName',
    },
    {
      title: '曝光',
      dataIndex: 'exposure',
    },
    {
      title: '点击',
      dataIndex: 'clicks',
    },
    {
      title: '日消耗',
      dataIndex: 'dayConsume',
    },
    {
      title: '点击率',
      dataIndex: 'clickRate',
    },
    {
      title: '平均CPM',
      dataIndex: 'avgCpm',
    },
    {
      title: '平均CPC',
      dataIndex: 'avgCpc',
    },
  ]

  const relationsCol = [
    {
      title: '订单编号',
      dataIndex: 'orderNumber',
    },
    {
      title: '类型',
      dataIndex: 'orderType',
      render: text => {
        return text === 0 ? '直销' : '代理商'
      }
    },
    {
      title: '订单类型',
      dataIndex: 'orderCategory',
      render: text => {
        return text === 0 ? '提单' : '退单'
      }
    },
    {
      title: '厂商ID',
      dataIndex: 'vendorId',
    },
    {
      title: '项目',
      dataIndex: 'project',
    },
    {
      title: '产品',
      dataIndex: 'product',
    },
    {
      title: '业务类型',
      dataIndex: 'businessType',
    },
    {
      title: '市场价',
      dataIndex: 'marketPrice',
    },
    {
      title: '预计收款',
      dataIndex: 'predictPrice',
    },
    {
      title: '收款类型',
      dataIndex: 'paymentType',
    },
    {
      title: '订单负责人',
      dataIndex: 'manager',
    },
  ]

  const businessApproversCol = [
    {
      title: '审批人',
      dataIndex: 'staffName',
    },
    {
      title: '客户已付金额/回款',
      dataIndex: 'repaymentAmount',
    },
    {
      title: '回款主体',
      dataIndex: 'repaymentSubject',
    },
    {
      title: '客户结算单邮箱',
      dataIndex: 'emails',
      render: text => (
        <>
          {text && JSON.parse(text).map((item, index) => (
            <div key={index}>{item.email}{item.tip !== '' && `(${item.tip})`}</div>
          ))}
        </>
      )
    },
    {
      title: '附件上传',
      dataIndex: 'attachments',
      render: text => (
        <>
          {text && JSON.parse(text).map((item, index) => (
            <div key={index}><a href={item.url} target="_blank">{item.name}</a></div>
          ))}
        </>
      )
    },
    {
      title: '备注信息',
      dataIndex: 'remark',
    },
  ]

  const statusLogsCol = [
    {
      title: '状态类型',
      dataIndex: 'typeName',
    },
    {
      title: '申请人',
      dataIndex: 'applicant',
    },
    {
      title: '状态',
      dataIndex: 'statusName',
    },
    {
      title: '附件',
      dataIndex: 'attachments',
      render: text => (
        <>
          {text.type === 'images' && text.content.map((item, index) => (
            <div key={index}><a href={item.url} target="_blank">{item.name}</a></div>
          ))}
          {text.type === 'text' && <div>{text.content}</div>}
        </>
      )
    },
    {
      title: '备注',
      dataIndex: 'remark',
    },
    {
      title: '申请时间',
      dataIndex: 'addTime',
    },
  ]

  const addEmailAddress = () => {
    if (regExt.mail.test(emailAddress)) {
      setCustomEmails([...customEmails, { email: emailAddress, tip: '', selected: false, source: 3 }])
      const val = getFieldValue('customEmails')
      val.push(emailAddress)
      setFieldsValue({
        customEmails: val
      })
      setEmailAddress('')
      setEmailVisible(false)
    } else {
      message.error('请输入正确的邮箱地址')
    }
  }

  const handlePass = () => {
    let params = {
      id: order.id,
      type: 1,
    }
    if (order.currentApproverType === 1) {
      let flag = false
      setFieldsValue(allTrim(getFieldsValue()))
      validateFields(err => {
        if (err) {
          flag = true
        }
      })
      if (flag) {
        message.error('请填写必填项')
        return
      }
      const vals = filterParams(getFieldsValue())
      if (vals.repaymentAmount) {
        params.repaymentAmount = vals.repaymentAmount
      }
      if (vals.attachments) {
        params.attachments = vals.attachments.map(item => {
          const { name, url } = item
          return {
            name,
            url,
          }
        })
      }
      if (vals.remark) {
        params.remark = vals.remark
      }
      const arr1 = contractEmails.filter(item => vals.contractEmails.includes(item.email)).map(item => {
        return {
          email: item.email,
          source: item.source,
          tip: item.tip,
        }
      })
      const arr2 = orderEmails.filter(item => vals.orderEmails.includes(item.email)).map(item => {
        return {
          email: item.email,
          source: item.source,
          tip: item.tip,
        }
      })
      const arr3 = customEmails.filter(item => vals.customEmails.includes(item.email)).map(item => {
        return {
          email: item.email,
          source: item.source,
          tip: item.tip,
        }
      })
      params.emails = [...arr1, ...arr2, ...arr3]
      params.repaymentSubject = vals.repaymentSubject
      if (order.repaymentOaid === '') {
        message.error('未在系统中查到该回款主体，请检查后重新输入')
        return
      }
    }
    setLoading(true)
    api.approveSettlementOrder(params).then(() => {
      message.success('审批完成')
      getDetail()
      setLoading(false)
    }).catch(() => setLoading(false))
  }

  const handleReject = () => { 
    let params = {
      id: order.id,
      type: 2,
    }
    if (order.currentApproverType === 1) { 
      if (remark) {
        params.remark = remark
      }
    } else { 
      if (rejectApprovers.length === 0) {
        message.error('业务审批人')
        return
      }
      if (remark === '') {
        message.error('请输入驳回审批意见')
        return
      }
      params.rejectedApproverIds = rejectApprovers
      params.remark = remark
    }
    setConfirmLoading(true)
    api.approveSettlementOrder(params).then(() => {
      message.success('审批完成')
      getDetail()
      setRejectVisible(false)
      setConfirmLoading(false)
    }).catch(() => setConfirmLoading(false))
  }

  const handleSearchRepaymentSubject = evt => {
    const name = evt.target.value.trim()
    if (name === '') {
      order.repaymentOaid = ''
      setOrder({ ...order })
      return
    }
    api.getOaIdByClientName({
      name: evt.target.value.trim(),
      type: order.clientType === 0 ? 1 : 2
    }).then(data => {
      if (data.id === 0) {
        order.repaymentOaid = ''
        setOrder({ ...order })
        message.error('未在系统中查到该回款主体，请检查后重新输入')
      } else {
        order.repaymentOaid = data.id
        setOrder({ ...order })
      }
    })
  }

  return (
    <Spin spinning={loading}>
      <div className="pro-detail">
        <Descriptions 
          layout="vertical"
          column={5}
          style={{ marginBottom: '10px' }}
        >
          <DItem label="结算单编号">{order.settlementNo}</DItem>
          <DItem label="结算单月份">{order.settlementMonth}</DItem>
          <DItem label="对方主体">{order.clientName}</DItem>
          <DItem label="我方主体">{order.companyName}</DItem>
          <DItem label="结算方式">{order.settlementMethodName}</DItem>
          <DItem label="系统充值">{order.systemRecharge}</DItem>
          <DItem label="本月消耗">{order.monthConsume}</DItem>
          <DItem label="应付金额">{order.payable}</DItem>
          <DItem label="业务审批人">{order.businessApprovers?.map(item => item.staffName).join(',')}</DItem>
          <DItem label="内控审批人">{order.internalApproverName}</DItem>
        </Descriptions>
        <div className="line-box"></div>
        {statusLogs.length > 0 && (
          <>
            <Descriptions 
              title="结算单状态信息"
              className="pro-detail-smailtitle"
            >
            </Descriptions>
            <Table 
              rowKey={(record, i) => i}
              columns={statusLogsCol} 
              dataSource={statusLogs} 
              pagination={false}
              bordered
              style={{ marginBottom: '20px' }}
              size="middle"
            />
            <div className="line-box"></div>
          </>
        )}
        <Descriptions 
          title="消耗汇总"
          className="pro-detail-smailtitle"
        >
        </Descriptions>
        <Table 
          rowKey={(record, i) => i}
          columns={consumeSummaryCol} 
          dataSource={order.consumeSummary} 
          pagination={false}
          bordered
          style={{ marginBottom: '20px' }}
          size="middle"
        />
        <div className="line-box"></div>
        <Descriptions 
          title="账户数据"
          className="pro-detail-smailtitle"
        >
        </Descriptions>
        <Table 
          rowKey={(record, i) => i}
          columns={accountDataCol} 
          dataSource={order.accountData} 
          pagination={false}
          bordered
          style={{ marginBottom: '20px' }}
          size="middle"
        />
        <div className="line-box"></div>
        <Descriptions 
          title="消耗明细"
          className="pro-detail-smailtitle"
        >
        </Descriptions>
        <Table 
          rowKey={(record, i) => i}
          columns={consumeDetailCol} 
          dataSource={order.consumeDetail} 
          pagination={false}
          bordered
          style={{ marginBottom: '20px' }}
          size="middle"
        />
        <div className="line-box"></div>
        <Descriptions 
          title="结算单关联订单"
          className="pro-detail-smailtitle"
        >
        </Descriptions>
        <Table 
          rowKey={(record, i) => i}
          columns={relationsCol} 
          dataSource={relations} 
          pagination={false}
          bordered
          style={{ marginBottom: '20px' }}
          size="middle"
        />
        <div className="line-box"></div>
        <Descriptions 
          title="结算单审批信息"
          className="pro-detail-smailtitle"
        >
        </Descriptions>
        <Table 
          rowKey={(record, i) => i}
          columns={businessApproversCol} 
          dataSource={order.businessApprovers} 
          pagination={false}
          bordered
          style={{ marginBottom: '20px' }}
          size="middle"
        />
        {order.canApprove && order.currentApproverType === 1 && (
          <>
            <div className="line-box"></div>
            <Descriptions
              title="结算单审批"
              className="pro-detail-smailtitle"
            >
            </Descriptions>
            <Form {...formItemLayout}>
              <Row>
                <Col span={12}>
                  <FormItem label="客户已付金额/回款" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
                    {getFieldDecorator('repaymentAmount')(
                      <InputNumber
                        step={0.01}
                        min={0}
                        placeholder="请输入已付金额/回款金额（保留2位小数）"
                        style={{ width: '100%' }}
                      />
                    )}
                  </FormItem>
                </Col>
                <Col span={12}>
                  <FormItem label="客户资金主体当前余额" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
                    {order.customerFundBalance}
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span={12}>
                  <FormItem label="回款主体" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
                    {getFieldDecorator('repaymentSubject', {
                      initialValue: order.repaymentSubject,
                      rules: [{ required: true, message: '请输入回款主体' }]
                    })(
                      <Input
                        placeholder="请输入回款主体"
                        style={{ width: '100%' }}
                        onBlur={handleSearchRepaymentSubject}
                      />
                    )}
                  </FormItem>
                </Col>
                <Col span={12}>
                  <FormItem label="回款主体OAID/QID" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
                    {order.repaymentOaid}
                  </FormItem>
                </Col>
              </Row>
              <FormItem label="客户结算单邮箱" labelCol={{ span: 2 }} wrapperCol={{ span: 22 }} required>
                <FormItem label="合同联系人邮箱" labelCol={{ span: 2 }} wrapperCol={{ span: 20 }}>
                  {getFieldDecorator('contractEmails', {
                    initialValue: contractEmails.filter(item => item.selected).map(item => item.email),
                  })(
                    <Checkbox.Group style={{ width: '100%' }} >
                      {contractEmails.map((item, index) => (
                        <Checkbox key={index} value={item.email} disabled={item.selected}>{item.email}</Checkbox>
                      ))}
                    </Checkbox.Group>
                  )}
                </FormItem>
                <FormItem label="订单联系人邮箱" labelCol={{ span: 2 }} wrapperCol={{ span: 20 }}>
                  {getFieldDecorator('orderEmails', {
                    initialValue: orderEmails.filter(item => item.selected).map(item => item.email),
                  })(
                    <Checkbox.Group style={{ width: '100%' }} >
                      {orderEmails.map((item, index) => (
                        <Checkbox key={index} value={item.email} disabled={item.selected}>{item.email}</Checkbox>
                      ))}
                    </Checkbox.Group>
                  )}
                </FormItem>
                <FormItem label="自定义邮箱" labelCol={{ span: 2 }} wrapperCol={{ span: 20 }}>
                  <div style={{ display: 'flex', alignItems: 'center', height: '40px' }}>
                    <Icon type="plus" style={{ fontSize: '20px', marginRight: '10px' }} onClick={() => setEmailVisible(true)} />
                    {getFieldDecorator('customEmails', {
                      initialValue: customEmails.filter(item => item.selected).map(item => item.email),
                      rules: [{
                        validator: (_, value, callback) => {
                          if (getFieldValue('contractEmails').length === 0 && 
                            getFieldValue('orderEmails').length === 0 && value.length === 0) {
                            callback('请选择客户结算单邮箱')
                          } else {
                            callback()
                          }
                        }
                      },]
                    })(
                      <Checkbox.Group style={{ width: '100%' }} >
                        {customEmails.map((item, index) => (
                          <Checkbox key={index} value={item.email} disabled={item.selected}>{item.email}</Checkbox>
                        ))}
                      </Checkbox.Group>
                    )}
                  </div>
                </FormItem>
              </FormItem>
              <FormItem label="附件上传">
                {getFieldDecorator('attachments', {
                  valuePropName: 'fileList',
                  getValueFromEvent: draggerObj.normFile,
                })(
                  <Dragger {...draggerObj}>
                    <p className="ant-upload-drag-icon">
                      <Icon type="inbox" />
                    </p>
                    <p className="ant-upload-text">点击或将文件拖拽到这里上传</p>
                    <p className="ant-upload-hint">
                      支持扩展名：.jpg、.jpeg、.png、.pdf<br/>单个文件大小不超过20M，不超过20个附件。
                    </p>
                  </Dragger>
                )}
              </FormItem>
              <FormItem label="备注信息">
                {getFieldDecorator('remark')(
                  <Input.TextArea placeholder="请输入备注信息" rows={4} maxLength={500}/>
                )}
              </FormItem>
            </Form>
          </>
        )}
        <div className="line-box"></div>
        <Descriptions
          title="审批记录"
          className="pro-detail-smailtitle"
        >
        </Descriptions>
        <Table
          dataSource={logConList}
          rowKey={(record, i) => i}
          pagination={false}
        >
          <Column title="姓名" dataIndex="approverName" />
          <Column title="时间" dataIndex="addTime" />
          <Column title="状态" dataIndex="approverStatusMsg" />
          <Column title="审批意见" dataIndex="remark" />
        </Table>
        {order.canApprove && (
          <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '40px' }}>
            <Button onClick={() => setRejectVisible(true)}>驳回</Button>
            <Button type="primary" onClick={handlePass} style={{ marginLeft: '15px' }}>通过</Button>
          </div>
        )}
        <Modal
          title={<>确认驳回 <Icon type="close-circle" theme="twoTone" twoToneColor="#DC143C" /></>}
          visible={rejectVisible}
          onOk={handleReject}
          onCancel={() => setRejectVisible(false)}
          loading={confirmLoading}
        >
          {order.currentApproverType === 1 ? (
            <div>
              <div>审批意见:</div>
              <Input.TextArea 
                placeholder="请输入审批意见" 
                value={remark} 
                onChange={evt => setRemark(evt.target.value.trim())} 
                maxLength={500} 
              />
            </div>
          ) : (
            <div>
              <div><span style={{ color: 'red', marginRight: '5px', fontSize: '18px' }}>*</span>驳回给业务审批人:</div>
              <Checkbox.Group
                value={rejectApprovers}
                onChange={checkedValues => setRejectApprovers(checkedValues)}
              >
                {order.businessApprovers?.map((item, index) => (
                  <Checkbox key={index} value={item.staffId}>{item.staffName}</Checkbox>
                ))}
              </Checkbox.Group>
              <div style={{ paddingTop: '20px' }}><span style={{ color: 'red', marginRight: '5px', fontSize: '18px' }}>*</span>审批意见:</div>
              <Input.TextArea 
                placeholder="请输入审批意见" 
                value={remark} 
                onChange={evt => setRemark(evt.target.value.trim())} 
                maxLength={500} 
              />
            </div>
          )}
        </Modal>
        <Modal
          title="增加自定义客户结算单邮箱"
          visible={emailVisible}
          onOk={addEmailAddress}
          onCancel={() => setEmailVisible(false)}
        >
          <div>
            <Input 
              placeholder="请输入邮箱" 
              value={emailAddress} 
              onChange={evt => setEmailAddress(evt.target.value.trim())} 
            />
            <span style={{ color: 'red' }}>注意：增加自定义客户结算单邮箱时，请在附件中上传“客户对公邮箱或合同授权邮箱证明”。</span>
          </div>
        </Modal>
      </div>
    </Spin>
  )
}

export default Form.create()(Detail)
